import { locale } from './langs'
import Constants from 'scripts/base/Constants'
import {isClient, getMatchedRoute} from 'scripts/lib/utils'
import {routes} from 'scripts/routes'

if (isClient() && routes) {
  const path = window.location.pathname
  const { match } = getMatchedRoute({routes, path})
  locale.setLanguage(match.params['lang'] || Constants.DefaultLang)
}

export const getLang = () => {
  return locale.getLanguage() || Constants.DefaultLang
}

export const langPrefix = (props) => {
  const currLang = (props && props.lang) || getLang()
  const prefix = (currLang !== Constants.DefaultLang ? `${currLang}` : '')
  if (prefix === '') { return '' }
  return (props && props.trailingSlash) ? `${prefix}/` : `/${prefix}`
}

export default locale



// WEBPACK FOOTER //
// ./shared-assets/i18n/react.js